module.exports = __webpack_public_path__ + "img/anniversaire2.2ccd4646.jpg";